/**
 * proto RetailerDraft → RetailerEditRow への変換。
 *
 * GetDemandForecastDaily が返す各小売の draft 状態を、画面のローカル編集行
 * (RetailerEditRow) に落とす純関数。index.tsx の editRows 初期化が「dirty でない
 * 行は API 値でリフレッシュ / 新規行は API 値で生成」の 2 箇所で同一変換を書いて
 * いたのを 1 箇所に集約する。
 */
import type { RetailerDraft } from '@ebalance/proto/bffuser/v1/demand_forecast_service_pb'

import { protoSlotsToKoma } from '~/pages/DemandForecastDaily/models/slotHelpers'
import type { RetailerEditRow } from '~/pages/DemandForecastDaily/models/types'

/**
 * proto RetailerDraft を clean (baseline === 現在値) の RetailerEditRow に
 * 変換する。
 * dirty は保存しない導出値のため、baseline に現在値と同じ snapshot を積んで
 * `computeForecastDiff` が isDirty=false を返す状態を作る (明示保存モデル、
 * 設計書 §5)。
 */
export function protoRetailerToEditRow(
  retailer: RetailerDraft,
): RetailerEditRow {
  const fields = {
    forecastSlots: protoSlotsToKoma(retailer.forecastSlots),
    providerSlots: protoSlotsToKoma(retailer.providerSlots),
    manualEditKomas: new Set(retailer.manualEditKomas),
    provider: retailer.provider,
    providerOther: retailer.providerOther,
    providerLabel: retailer.providerLabel,
  }
  return {
    retailerBusinessCd: retailer.retailerBusinessCd,
    displayName: retailer.displayName,
    unit: { kind: 'retailer' },
    carriedOverFromGroups: retailer.carriedOverFromGroups,
    ...fields,
    draftUpdatedAt: retailer.draftUpdatedAt,
    baseline: { ...fields, manualEditKomas: new Set(fields.manualEditKomas) },
  }
}
